'use client';

import { useTranslations } from 'next-intl';
import {
  isArchivedLifecycle,
  isCodeDeletedLifecycle,
} from '@terra/shared-dto-types';
import { Badge } from './badge';

type ArchivedLifecycleBadgeProps = {
  lifecycle: { state: string; origin?: string | null } | null | undefined;
};

export const ArchivedLifecycleBadge = ({
  lifecycle,
}: ArchivedLifecycleBadgeProps) => {
  const t = useTranslations('designSystem.common');
  const label = isCodeDeletedLifecycle(lifecycle)
    ? t('deletedFromCode')
    : isArchivedLifecycle(lifecycle)
      ? t('outOfScope')
      : null;

  if (!label) {
    return null;
  }

  return (
    <Badge variant="emphasis" size="sm">
      {label}
    </Badge>
  );
};
